import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router, ActivatedRoute } from '@angular/router';

import introJs from 'intro.js/intro.js';
import { environment } from '../../environments/environment';

declare var require: any;
const dfnRMApp = environment.dfnRMApp;
const intranet = environment.intranet;

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./nav-bar.component.css',
    '../../style.scss',]
})
export class NavBarComponent implements OnInit {

  isClient: boolean;


  userName = localStorage.getItem('userName');
  userEmail = localStorage.getItem('userEmail');
  isTour = localStorage.getItem('isTour');
  image = localStorage.getItem('userImage');
  externalUSer = localStorage.getItem('externalUser');
  sessionId = localStorage.getItem('jiraSession');
  showPasswordChange: boolean;
  showVersion: boolean;
  isNewRelease:any;



  checkClient() {
    this.isClient = this.userEmail.includes("@");
  }


  checkExternalUser() {
    // console.log("This.sessionID", this.sessionId);
    if(this.sessionId.startsWith("External")){
      this.showPasswordChange = true;
      // console.log("This.sessionID start with External", this.sessionId);
    }else{
      // console.log("This.sessionID does not start with External", this.sessionId);
    }
   
  }

  changePassword(){
    console.log("Change Password");
    this.router.navigate(['/changePassword']);
  }

  logout() {

    this.authService.logout();

    if(this.externalUSer == 'true'){
      this.router.navigate(['/ExternalLogin']);
    }else{
      window.location.href = intranet + "/intranet";
    }

  }

  startTour() {
    console.log("Starting tour");

    localStorage.setItem('isTour', 'true');

    console.log("inside intro.js");
    introJs.introJs().setOptions({
      'doneLabel': '<span style="color: green; font-weight:bold;">Next page</span>',
      'keyboardNavigation': 'false',
      steps: [
        {
          element: '#step00',
          intro: '<b>Hello <i class="fa fa-smile-wink"></i>  ,  Welcome To DFN Release Manager</b>',
          position: 'bottom'
        }, {
          element: '#step01',
          intro: '<i class="fa fa-home"></i>  Our First Destination will Display Latest Release Details.',
          position: 'bottom'
        },
        {
          element: '#step02',
          intro: '<i>Latest Release Details are Displayed. </i> ',
          position: 'bottom'
        },
        {
          element: '#step03',
          intro: '<i>You can Filter by multiple Projects. </i> ',
          position: 'bottom'
        },
        {
          element: '#step04',
          intro: '<i>You can Filter by multiple Components. </i> ',
          position: 'bottom'
        },
        {
          element: '#step33',
          intro: '<span style="color: blue; font-weight:bold;">Our Next Destination will show you how to add a new Release.</span>',
          position: 'bottom'
        }]
    })
      .start()
      .oncomplete(function () {
        window.location.href = '/New-Release?intro=true';
      });

  }

  constructor(public authService: AuthService, public router: Router, private route: ActivatedRoute, ) {
  }

  ngOnInit() {
    this.checkClient();
    
    this.checkExternalUser();

    this.showVersion = (this.route.snapshot.url[0].path === 'New-Release');

    setTimeout(() => {
      this.image = localStorage.getItem('userImage');
    },
      100);

  }

}
